module.exports = __webpack_public_path__ + "img/39e5aec.jpg";